import React from 'react';
import '../Screen.css';
import RichText from '../RichText';

function ChoiceScreen({ block, variables = {}, onNext }) {
  const buttons = block.buttons || [];

  const handleButtonClick = (button) => {
    if (button.nextId) {
      // Передаем value кнопки (если есть), иначе текст, и nextId
      // Важно: сохраняем оригинальное значение (может быть boolean, string, number)
      const valueToPass = button.value !== undefined ? button.value : button.text;
      onNext(valueToPass, button.nextId);
    }
  };

  return (
    <div className="screen">
      <div className="screen-content">
        <h1 className="large-text">
          <RichText text={block.text} variables={variables} />
        </h1>
        <div className="choice-buttons">
          {buttons.map((button, index) => (
            <button
              key={index}
              className="button choice-button"
              onClick={() => handleButtonClick(button)}
            >
              {button.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ChoiceScreen;

